import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Chip,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck";
import PremissionDialog from "../../customComponent/premissionDialog";
import CourseMajorMain from "./courseMajorMain";
import SubjectMajorMain from "./subjectMajorMain";
import CourseLevelMajorMain from "./courseLevelMajorMain";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginBottom: theme.spacing(2),
    marginTop: "8px",
  },
  hoverElement: {
    "&:hover": {
      color: "#FE0B7A", // Set the hover color
    },
    "&.clicked": {
      backgroundColor: "#FE0B7A",
      color: "white",
    },
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
  },
  searchInput: {
    marginLeft: theme.spacing(1),
  },
}));

function CourseMasterMain(props) {
  const navigate = useNavigate();
  const { privilege, hasPrivilege, isCreatePrevilage } = usePrivilegeCheck();

  const classes = useStyles();
  const [clicked, setClicked] = useState("courseMajor");
  const [addFormCountry, setAddFormCountry] = useState(false);
  const [addFormState, setAddFormState] = useState(false);
  const [addFormCity, setAddFormCity] = useState(false);
  const [searchvalue, setSearchValue] = useState("");
  const [openAlert, setOpenAlert] = useState(false);

  // HandleClose dialog

  const handleCloseDialog = () => {
    setOpenAlert(false);
  };

  const handleClick = (master) => {
    setClicked(master);
  };

  const handleModalClick = () => {
    if (clicked === "Categories") {
      setAddFormCountry(true);
    }

    if (clicked === "Topics") {
      setAddFormState(true);
    }
  };

  //   const searchHandleChange = (value) => {
  //     setSearchValue(value);
  //   };

  if (!hasPrivilege("Course Master") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }
  return (
    <>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <Chip
            className={`${classes.hoverElement} ${
              clicked === "courseMajor" ? "clicked" : ""
            }`}
            label="Major Master"
            component="a"
            clickable
            sx={{ m: 1 }}
            onClick={() => handleClick("courseMajor")}
          />
          <Chip
            className={`${classes.hoverElement} ${
              clicked === "courseSubject" ? "clicked" : ""
            }`}
            label="Subject Master"
            component="a"
            clickable
            sx={{ m: 1 }}
            onClick={() => handleClick("courseSubject")}
          />
          <Chip
            className={`${classes.hoverElement} ${
              clicked === "courseLevel" ? "clicked" : ""
            }`}
            label="Course level Master"
            component="a"
            clickable
            sx={{ m: 1 }}
            onClick={() => handleClick("courseLevel")}
          />
        </Grid>
      </Grid>

      {clicked === "courseMajor" && <CourseMajorMain subMenu="Course Master" />}
      {clicked === "courseSubject" && (
        <SubjectMajorMain subMenu="Course Master" />
      )}
      {clicked === "courseLevel" && (
        <CourseLevelMajorMain subMenu="Course Master" />
      )}

      {openAlert && (
        <PremissionDialog
          openAlert={openAlert}
          handleClose={handleCloseDialog}
        />
      )}
    </>
  );
}

export default CourseMasterMain;
